import { render, staticRenderFns } from "./DenominationExchange.vue?vue&type=template&id=57ad79b0"
import script from "./DenominationExchange.vue?vue&type=script&lang=js"
export * from "./DenominationExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports